import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-refer-friend',
  templateUrl: './refer-friend.component.html',
  styleUrls: ['./refer-friend.component.scss']
})
export class ReferFriendComponent implements OnInit {

  referLink=""
  constructor(public auth:AuthService,public messageService:MessageService,public common:CommonService) { }

  ngOnInit(): void {
    this.auth.getReferLink().subscribe((res:any)=>{
      //console.log(res.referLink)
      this.referLink= environment.app_url + res.referLink
    },err=>{
      //console.log(err)
    })
  }

  copyMessage(message) {
    if(message){
      //console.log(message)
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = message;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.messageService.add({severity:'success', summary:'Copied', detail:""});
    //console.log("link copied!")
    }
  }

  refer(referform:NgForm){
    this.common.showLoader()
    this.auth.sendReferEmail(referform.value.email).subscribe(res=>{
      //console.log(res)
      this.common.stopLoader()
      referform.resetForm()
      // this.messageService.add({severity:'success', summary:'Success', detail:"Refer Email send to your friend"});
    },err=>{
      //console.log(err)
      this.common.stopLoader()
      this.messageService.add({severity:'error', summary:'err.message', detail:""});
    })
  } 
}
